<template>
  <section id="main-container" style="background-color: rgb(230, 230, 230);">
    <v-container fluid>
      <v-layout flex>
        <v-flex xs12 style="max-width:1020px;margin:0 auto;">
          <div id="centered-content">
            <img
              height="160px"
              style="margin:0 auto; display:block; padding-bottom:40px; "
              slot="activator"
              src="../assets/login-cb-logo.svg"
            />
            <v-layout wrap row>
              <v-flex
                xs12
                md6
                class="login-box pa-4"
                style="border-top-right-radius: 5px;border-bottom-right-radius: 0px; border-bottom-left-radius: 0px;border-top-left-radius: 5px;'"
                :style="$vuetify.breakpoint.mdAndUp && 'border-top-right-radius: 0px;border-bottom-right-radius: 0px; border-bottom-left-radius: 5px;border-top-left-radius: 5px;'"
              >
                <!-- if no promo box simply add class 'no-promo' to the above v-flex. -->
                <v-flex style="display:table; height:100%; width:100%;" class="pa-4">
                  <div style="display:table-cell; vertical-align:middle;">
                    <v-layout v-if="logoUrl" class="brand-logo mb-4 px-4 mx-4">
                      <img class="" :src="logoUrl"/> <!-- Image width is 318px.-->
                    </v-layout>
                    <!--<h1 class="primary--text pb-3">Login</h1>-->
                    <v-form ref="form" @keyup.native.enter="submit">
                      <p>Using your password management app or authenticator app, please enter the current one-time password.</p>
                      <v-text-field
                        box
                        label="One-Time Password"
                        v-model="password"
                        type="text"
                        @click:append="showPass = !showPass"
                        min="6"
                        required
                        class="mb-0"
                      ></v-text-field>

                      <v-btn class="ml-0 mb-4 mt-0" color="tertiary" block @click="submit" :loading="loading" aria-label="Login">Login</v-btn>
                      <v-alert
                        id="submit-feedback"
                        :value="showValidationMessage"
                        :type="flashSeverity"
                        class="mb-3"
                        style="margin-top:-10px;"
                      >{{ validationMessage }}</v-alert>
                    </v-form>
                  </div>
                </v-flex>
              </v-flex>
              <v-flex
                xs12
                md6
                class="promo-box pa-4"
                style="border-top-right-radius: 0px;border-bottom-right-radius: 5px; border-bottom-left-radius: 5px;border-top-left-radius: 0px;'"
                :style="$vuetify.breakpoint.mdAndUp && 'border-top-right-radius: 5px;border-bottom-right-radius: 5px; border-bottom-left-radius: 0px;border-top-left-radius: 0px;'"
              >
                <v-flex style="display:table; height:100%;width:100%;" class="pa-4">
                  <div style="display:table-cell; vertical-align:middle;">
                    <h2 class="pb-2" style="line-height:1.2em;">
                      Explore the latest new
                      features in Caseblocks
                    </h2>
                    <p>
                      We’ve been busy developing and expanding Caseblocks
                      core functionalilty to make it even better.
                    </p>
                    <a href="https://caseblocks.com" class="no-link-style">
                      <v-btn class="ml-0 mt-1" color="secondary" outline>Explore</v-btn>
                    </a>
                  </div>
                </v-flex>
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>
<script>
import { mapState } from "vuex"

export default {
  name: "mfa",
  components: {},
  data: () => {
    return {
      loader: null,
      loading: false,
      password: "",
      showPass: false,
      logoUrl: "", // To be replaced with url to uploaded account logo
    }
  },
  watch: {
    loader () {
      const l = this.loader
      this[l] = !this[l]

      setTimeout(() => (this[l] = false), 3000)

      this.loader = null
    }
  },
  methods: {
    submit() {
      this.loader = 'loading'
      this.$store.dispatch("requestMFALogin", {
        totp: this.password,
        next: this.$route.query.next
      })
    }
  },
  computed: {
    showValidationMessage() {
      return !!this.validationMessage
    },
    validationMessage() {
      return this.flashMessage ? this.flashMessage.message : undefined
    },
    flashSeverity() {
      if (this.flashMessage && this.flashMessage.severity === "success") {
        return "success"
      }
      if (this.flashMessage && this.flashMessage.severity === "warning") {
        return "warning"
      }
      return "error"
    },
    ...mapState({
      flashMessage: state => state.ui.flashMessage
    })
  }
}
</script>
<style>
#main-container {
  min-height: 100vh;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}

#centered-content {
  -webkit-box-shadow: none;
  box-shadow: none;
  padding: 0;
}

#centered-content h1 {
  font-size: 2.9em;
}

.login-box {
  background: white;
}

.login-box.no-promo {
  margin: 0 auto;
  border-radius: 5px !important;
}

.promo-box {
  background: #fbb6b6;
}

.brand-logo img {
   max-width:100%;
 max-height:100%;
}
</style>
